/*
 * Moves STOQ's (formerly Restock Rocket) "Notify me when available" button out
 * of Horizon's hidden sticky add-to-cart bar and into the slot rendered by the
 * CHPO sold out note block, and adds a product row to STOQ's pop-up. Watches the
 * page because STOQ adds the button and pop-up late. Pop-up styles are in
 * chpo-apps.css.
 */
(function () {
  if (window.chpoRestockSlot) return;
  window.chpoRestockSlot = true;

  var CONTAINER = '.restock-rocket-button-container';

  function place() {
    var slot = document.querySelector('[data-chpo-restock-slot]');
    if (!slot) return;
    var buttons = document.querySelectorAll(CONTAINER);
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      if (slot.contains(button)) continue;
      if (slot.querySelector(CONTAINER)) {
        // STOQ re-added a button after a variant change: keep the newest one.
        slot.innerHTML = '';
      }
      slot.appendChild(button);
    }
  }

  // Adds a product row (photo, name, colour) to STOQ's pop-up, from this page.
  function productRow() {
    var name = document.querySelector('#restock-rocket #form-Product-Name');
    if (!name || name.parentNode.querySelector('.chpo-stoq-product')) return;
    var title = document.querySelector('.product-details h1, main h1');
    if (!title) return;
    var meta = document.querySelector('.chpo-pdp-subtitle');
    var og = document.querySelector('meta[property="og:image:secure_url"], meta[property="og:image"]');

    var row = document.createElement('div');
    row.className = 'chpo-stoq-product';
    if (og && og.content) {
      var img = document.createElement('img');
      img.className = 'chpo-stoq-product__img';
      img.alt = '';
      img.src = og.content + (og.content.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      row.appendChild(img);
    }
    var text = document.createElement('div');
    var t = document.createElement('span');
    t.className = 'chpo-stoq-product__title';
    t.textContent = title.textContent.trim();
    text.appendChild(t);
    if (meta && meta.textContent.trim()) {
      var m = document.createElement('span');
      m.className = 'chpo-stoq-product__meta';
      m.textContent = meta.textContent.trim();
      text.appendChild(m);
    }
    row.appendChild(text);
    name.parentNode.insertBefore(row, name);
  }

  function update() {
    place();
    productRow();
  }

  function start() {
    update();
    new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
